// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".members-grid{display:grid;grid-column-gap:2rem;-webkit-column-gap:2rem;-moz-column-gap:2rem;column-gap:2rem;padding-top:1rem;padding-bottom:1rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:1.3rem;color:var(--text-text-secondary);font-weight:500;grid-template-columns:40% 1fr auto}.members-grid--header{font-size:1.3rem;color:var(--text-text-ternary)}", ""]);
// Exports
module.exports = exports;
